export enum LanguageCode {
    DE = "de",
    EN = "en",
    FR = "fr",
    IT = "it"
}

/**
 * The languages activated in the application and offered in the UI language switcher.
 *
 * EN and IT are excluded because the code tables the backend serves carry no translations for them
 * (refs #61689). They stay defined in {@link LanguageCode} so a language already in storage still
 * resolves to a known code.
 */
export const SELECTABLE_LANGUAGE_CODES: readonly LanguageCode[] = [LanguageCode.DE, LanguageCode.FR];

export const LANGUAGE_STORAGE_KEY = "kw-common-ng-i18n_CLIENT_LANGUAGE";
